import React from 'react';
import PublicLayout from '../Layout/PublicLayout';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <PublicLayout onLogin={() => navigate('/login')} onRegister={() => navigate('/register')}>
            <div style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1000px', margin: '0 auto', paddingLeft: '20px', paddingRight: '20px' }}>
                <h1 style={{ fontFamily: 'Orbitron', fontSize: '2.5rem', color: 'var(--primary-color)', marginBottom: '40px' }}>
                    Privacy Policy
                </h1>

                <div className="card" style={{ padding: '40px', lineHeight: '1.8', color: 'var(--text-secondary)' }}>
                    <p style={{ marginBottom: '20px' }}>
                        At **ZeroPing**, accessible from zeroping.app, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that is collected and recorded by ZeroPing and how we use it.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>1. Information We Collect</h3>
                    <p style={{ marginBottom: '20px' }}>
                        We collect information you provide directly to us when you register an account, participate in tournaments, or contact customer support. This includes:
                        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                            <li>Personal Information (Name, Email, Phone Number)</li>
                            <li>Gaming Profiles (BGMI Username, ID)</li>
                            <li>Payment Information (UPI ID, Transaction History)</li>
                        </ul>
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>2. How We Use Your Information</h3>
                    <p style={{ marginBottom: '20px' }}>
                        We use the collected information to:
                        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                            <li>Process tournament registrations and payments.</li>
                            <li>Verify user identity and prevent fraud.</li>
                            <li>Communicate important updates, results, and offers.</li>
                            <li>Improve platform functionality and user experience.</li>
                        </ul>
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>3. Data Security</h3>
                    <p style={{ marginBottom: '20px' }}>
                        We implement industry-standard security measures to protect your personal data. Your password and sensitive information are encrypted. However, no method of transmission over the internet is 100% secure.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>4. Third-Party Services</h3>
                    <p style={{ marginBottom: '20px' }}>
                        We may use third-party services for payment processing and analytics. These parties have their own privacy policies governing the use of your data.
                    </p>

                    <h3 style={{ color: 'var(--text-primary)', marginTop: '30px', marginBottom: '15px' }}>5. Contact Us</h3>
                    <p style={{ marginBottom: '20px' }}>
                        If you have any questions about this Privacy Policy, please contact us at support@zeroping.app.
                    </p>
                </div>
            </div>
        </PublicLayout>
    );
};

export default PrivacyPolicy;
